"use strict";
/**
 * This schema file should be used to house generic schemas relating to API queries,
 * and utility functions which can be used to generate more specific query parameter
 * schemas
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.paramsSchema = exports.offsetLimitOrderBy = exports.filterParamsSchema = exports.generateFilterParamsObject = exports.FilterUrlParamsSchema = exports.UrlParamsSchema = exports.FieldQueriesSchema = exports.FilterFieldQueriesSchema = exports.generateFieldQueryObject = exports.ColumnsParamSchema = exports.ColumnsSchema = exports.SpatialSchema = exports.LimitSchema = exports.OffsetSchema = exports.BooleanLiteralSchema = exports.SortOrderSchema = exports.SpatialOperatorSchema = exports.SpatialOperators = exports.BooleanOperatorSchema = exports.BooleanOperators = exports.StringOperatorSchema = exports.StringOperators = exports.ArrayOperatorSchema = exports.ArrayOperators = void 0;
const zod_1 = require("zod");
exports.ArrayOperators = ['eq', 'neq'];
exports.ArrayOperatorSchema = zod_1.z.enum(exports.ArrayOperators);
exports.StringOperators = ['lt', 'gt', 'lte', 'gte', 'in'];
exports.StringOperatorSchema = zod_1.z.enum(exports.StringOperators);
exports.BooleanOperators = ['null'];
exports.BooleanOperatorSchema = zod_1.z.enum(exports.BooleanOperators);
exports.SpatialOperators = ['inside'];
exports.SpatialOperatorSchema = zod_1.z.enum(exports.SpatialOperators);
exports.SortOrderSchema = zod_1.z.union([
    zod_1.z.literal('ASC'),
    zod_1.z.literal('DESC'),
    zod_1.z.literal('ASC NULLS LAST'),
    zod_1.z.literal('DESC NULLS LAST'),
]);
exports.BooleanLiteralSchema = zod_1.z.union([zod_1.z.literal('true'), zod_1.z.literal('false')]);
exports.OffsetSchema = zod_1.z.coerce.number().int().nonnegative().optional();
exports.LimitSchema = zod_1.z.coerce.number().int().positive().optional().or(zod_1.z.literal('ALL'));
exports.SpatialSchema = zod_1.z.string().or(zod_1.z.array(zod_1.z.string())).optional();
exports.ColumnsSchema = zod_1.z.string().optional();
exports.ColumnsParamSchema = zod_1.z.object({
    columns: exports.ColumnsSchema,
});
/**
 * Swagger docs schema section
 */
/**
 * This function generates objects that we want to appear in the field queries (eq, gt, lt etc) section of the swagger docs.
 */
const generateFieldQueryObject = (operatorArr, schema) => operatorArr.reduce((acc, operatorName) => ({
    ...acc,
    [`${operatorName}[resource.field_name]`]: schema,
}), {});
exports.generateFieldQueryObject = generateFieldQueryObject;
/**
 * This is the schema for field queries we want to allow for non paginated endpoints
 */
exports.FilterFieldQueriesSchema = zod_1.z.object({
    ...(0, exports.generateFieldQueryObject)([...exports.ArrayOperators, ...exports.StringOperators], zod_1.z.string()),
    ...(0, exports.generateFieldQueryObject)(exports.BooleanOperators, exports.BooleanLiteralSchema),
});
/**
 * This is the schema for field queries we want to allow for paginated endpoints
 * (same as above but with order by)
 */
exports.FieldQueriesSchema = exports.FilterFieldQueriesSchema.extend((0, exports.generateFieldQueryObject)(['order_by'], exports.SortOrderSchema));
/**
 * This schema is used to control the controls that are made available in the Swagger docs.
 */
exports.UrlParamsSchema = zod_1.z
    .object({
    offset: exports.OffsetSchema,
    limit: exports.LimitSchema,
    fieldQueries: exports.FieldQueriesSchema.optional(),
})
    .extend(exports.ColumnsParamSchema.shape);
/**
 * This schema is used to control the controls that are made available in the Swagger docs
 * for endpoints which don't support pagination (i.e. when the response is not an array)
 */
exports.FilterUrlParamsSchema = zod_1.z.object({
    fieldQueries: exports.FilterFieldQueriesSchema.optional(),
});
/**
 * END Swagger docs schema section
 */
/**
 * API endpoint params section
 */
/**
 * This function generates the schema for API request parameters based on a supplied schema.
 * It's used to ensure that requests are only made for fields that exist in the supplied schema.
 */
const generateFilterParamsObject = (operatorArr, schema) => operatorArr.reduce((acc, operatorName) => ({
    ...acc,
    [operatorName]: schema,
}), {});
exports.generateFilterParamsObject = generateFilterParamsObject;
/**
 * This function constructs the full schema for non paginated endpoints for a given schema
 * which defines the available fields for that endpoint.
 */
const filterParamsSchema = (schema) => zod_1.z.object({
    ...(0, exports.generateFilterParamsObject)(exports.StringOperators, zod_1.z.record(schema, zod_1.z.string()).optional()),
    ...(0, exports.generateFilterParamsObject)(exports.ArrayOperators, zod_1.z.record(schema, zod_1.z.union([zod_1.z.string(), zod_1.z.array(zod_1.z.string())])).optional()),
    ...(0, exports.generateFilterParamsObject)(exports.BooleanOperators, zod_1.z.record(schema, exports.BooleanLiteralSchema).optional()),
});
exports.filterParamsSchema = filterParamsSchema;
const offsetLimitOrderBy = (schema) => ({
    offset: exports.OffsetSchema,
    limit: exports.LimitSchema,
    order_by: zod_1.z.record(schema, exports.SortOrderSchema).optional(),
    columns: exports.ColumnsSchema,
});
exports.offsetLimitOrderBy = offsetLimitOrderBy;
/**
 * This function constructs the full schema for paginated endpoints for a given schema
 * which defines the available fields for that endpoint.
 */
const paramsSchema = (schema) => (0, exports.filterParamsSchema)(schema).extend((0, exports.offsetLimitOrderBy)(schema)).strict();
exports.paramsSchema = paramsSchema;
/**
 * END API endpoint params section
 */
//# sourceMappingURL=query.js.map